module.exports = __webpack_public_path__ + "img/icons8-list-bgb.c1baa3ef.svg";